import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

export const FormField: React.FC<{
  id: string;
  label: string;
  name: string;
  value: string;
  placeholder: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isInvalid: boolean;
  errorMessage: string | null;
  className?: string;
}> = ({
  id,
  label,
  name,
  value,
  placeholder,
  onBlur,
  onChange,
  isInvalid,
  errorMessage,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`field mb-5 ${className}`}>
      <label className="font-bold block mb-2">{t(label)}</label>
      <InputText
        id={id}
        placeholder={t(placeholder)}
        name={name}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        className={classNames({ 'p-invalid': isInvalid })}
      />
      {isInvalid && (
        <div className="flex align-items-center justify-content-start mt-1 mx-2">
          <small className="p-error">*{t(errorMessage)}</small>
        </div>
      )}
    </div>
  );
};
